<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.apptype.entrance']">
              <a-select
                allowClear
                :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"
                v-model="queryParam.entranceId"
              >
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.commonlink.linkName']">
              <j-input :placeholder="language['basedata.pleaseEnter']+language['emp.commonlink.linkName']" v-model="queryParam.linkName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.apptype.status']">
              <j-dict-select-tag :placeholder="language['column.pleaseChoose']+language['emp.apptype.status']" v-model="queryParam.status" dictCode="sys_portal_up_down" allowClear/>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd"  v-has="'empcommonlink:insert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" v-has="'empcommonlink:batchDel'"  @click="batchDel">
            <a-icon type="delete"/>
            {{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <template slot="linkUrl" slot-scope="text, record, index">
          <a-tooltip :title="record.linkUrl" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>35?text.substr(0,35)+"...":text)}}</span>
          </a-tooltip>
        </template>

        <template slot="imageSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ language['common.noPicture'] }}</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" alt="" style="font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            :title="language['ad.image']"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'empcommonlink:edit'" >{{language['common.edit']}}</a>
          <a-divider type="vertical" v-has="'empcommonlink:edit'"/>

          <a @click="publish(record)" v-has="'empcommonlink:updown'" v-if="record.status=='down'">{{language['sys.dict.appstatus.publish']}}</a>
          <a @click="unpublish(record)" v-has="'empcommonlink:updown'" v-if="record.status=='up'">{{language['sys.dict.appstatus.unpublish']}}</a>

          <a-divider type="vertical" v-has="'empcommonlink:updown'" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'empcommonlink:detail'" >
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'empcommonlink:delete'" >
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-entrance-common-link-modal ref="modalForm" @ok="modalFormOk"></emp-entrance-common-link-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpEntranceCommonLinkModal from './modules/EmpEntranceCommonLinkModal'
  import {getAction,getFileAccessHttpUrl,httpAction} from '@/api/manage';
  import { getDictItemsFromCache } from '@/api/api'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'EmpEntranceCommonLinkList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpEntranceCommonLinkModal
    },
    data () {
      return {
        description: 'emp_entrance_common_link管理页面',
        // 表头
        //columns: [],
        url: {
          list: "/hhemp/commonlink/empentrancecommonlinks",
          delete: "/hhemp/commonlink/empentrancecommonlink",
          deleteBatch: "/hhemp/commonlink/empentrancecommonlink/batch",
          exportXlsUrl: "/hhemp/commonlink/export-xls",
          importExcelUrl: "/hhemp/commonlink/import-excel",
          publish: "/hhemp/commonlink/publishstatus",
        },
        dictOptions:{},
        superFieldList:[],
        entrances:[{
          id:'',
          colName:'',
          entranceName:''
        }],
        statusList: [],
        applicationCode:'platform',
        previewVisible: false,
        previewImage: '',
      }
    },
    created() {
      this.getEntranceList();
      this.statusList = getDictItemsFromCache('sys_portal_up_down')
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.language['emp.apptype.entrance'],
              width:240,
              align:"center",
              dataIndex: 'entranceName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['emp.commonlink.linkNo'],
              width:200,
              align:"center",
              dataIndex: 'linkNo'
            },
            {
              title: this.language['emp.commonlink.linkName'],
              width:240,
              align:"center",
              dataIndex: 'linkName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['emp.commonlink.linkUrl'],
              width:260,
              align:"center",
              ellipsis: true,
              dataIndex: 'linkUrl',
              scopedSlots: {customRender: "linkUrl"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['emp.commonlink.default'] +this.language['ad.image'],
              width: 120,
              ellipsis:true,
              align:"center",
              dataIndex: 'imageUrl',
              scopedSlots: {customRender: "imageSlot"}
            },
            {
              title: this.language['emp.apptype.sort'],
              width:100,
              align:"center",
              dataIndex: 'sortNo'
            },
            {
              title: this.language['emp.apptype.status'],
              width:150,
              align:"center",
              dataIndex: 'status',
              customRender: (text) => {
                return filterDictText(this.statusList, text)
              },
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:200,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      },
    },
    methods: {
      initDictConfig(){
      },
      getEntranceList(){
        //httpAction("/hhemp/entrance/empcmsentrances2?status=Y", "", "get").then((res) => {
        httpAction("/hhemp/entrance/empcmsentrances?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
          }
        })
      },
      publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language["sys.dict.appstatus.publish"],
          content:this.language["emp.apptype.sureUpShelf"],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'up'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language["sys.dict.appstatus.unpublish"],
          content:this.language["emp.apptype.sureDownShelf"],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'down'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
